import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { TfiKey } from 'react-icons/tfi';
import s from './style.css';
import { Button } from '../../components';
import { auth } from '../../actions';
import Input from '../../components/Input';
import { colors } from '../../foundations';
const PasswordForm = (props) => {
    const [showPass, setShowPass] = useState(false);
    const [password, setPassword] = useState('');
    const history = useHistory();
    const handleKeydown = (event) => {
        if (event.key === 'Enter') {
            login();
        }
    };
    useEffect(() => {
        document.addEventListener('keydown', handleKeydown);
        return () => {
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [password]);
    const login = () => {
        setShowPass(false);
        props.login(password, () => {
            history.push('/vault/files/');
        });
    };
    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };
    return (React.createElement("div", { className: s.formContainer },
        React.createElement("div", { className: s.keyCircle },
            React.createElement(TfiKey, { size: 60, color: colors.primary })),
        React.createElement(Input, { placeholder: 'Enter your password', onChange: handlePasswordChange, style: { marginTop: '80px' }, password: true, autoFocus: true }),
        React.createElement(Button, { text: 'Log In', id: 'continue', style: { marginTop: '32px' }, onClick: login }),
        React.createElement("button", { type: 'button', className: s.dont, onClick: () => props.setForm('passwordRecovery') }, "Forgot password?")));
};
const connector = connect(null, { ...auth });
export default connector(PasswordForm);
